<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="项目销售分析" name="project-analysis"></el-tab-pane>
      <el-tab-pane label="产品销售分析" name="product-analysis"></el-tab-pane>
      <!-- <el-tab-pane label="套餐概况" name="package-analysis"></el-tab-pane> -->
      <el-tab-pane label="套餐概况" name="overview-analysis"></el-tab-pane>
      <el-tab-pane label="套餐销售分析" name="sales-analysis"></el-tab-pane>
      <el-tab-pane label="套餐划扣分析" name="deduction-analysis"></el-tab-pane>
      <el-tab-pane label="员工销售/劳动分析" name="employee-analysis"></el-tab-pane>
      <el-tab-pane label="赠品统计" name="give-analysis"></el-tab-pane>
    </el-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'project-analysis'
    };
  },
  watch: {
    $route(e) {
      this.activeName = e.name;
    },
    activeName() {
      const vm = this;
      this.$router.push({
        name: vm.activeName
      });
    }
  },
  activated() {
    this.activeName = this.$route.name;
  },
  methods() {
    // this.handleClick();
  },
};
</script>
